import { useEffect } from "react";

import { getNewsByIdApi } from "constants/ApiConst";
import useFetchUnreadNewsCount from "hooks/api/useFetchUnreadNewsCount";
import { useSwr } from "hooks/useSwr";

const useFetchNewsById = (id: string | null) => {
  const { mutate: mutateUnReadCount } = useFetchUnreadNewsCount();

  const { data, error, mutate, isValidating } = useSwr<NewsItemDetail>(id ? getNewsByIdApi(id).url : null, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  useEffect(() => {
    if (data) {
      mutateUnReadCount();
    }
  }, [data, mutateUnReadCount]);

  return {
    news: data,
    isLoading: !data && isValidating,
    isValidating,
    error,
    mutate,
  };
};

export default useFetchNewsById;
